
/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

import React, { ChangeEvent, useEffect, useState } from "react";
import { Card, Container } from "react-bootstrap";
import { useAuth } from "../../../../contexts/AuthContext";
import { QueryListProvider } from "../../../../component/solution/QueryList/QueryListContext";
import { QueryList } from "../../../../component/solution/QueryList/QueryList";
import { CastType, IQuery, IWhere } from "../../../../component/solution/Interfaces";
import { formatDateFull } from "../../../../component/solution/utils/AppUtil";
import { Search, X } from "lucide-react";

enum AdjustmentStatus {
    TO_PROCESS = "TO_PROCESS",
    PROCESSED = "PROCESSED",
    ERROR = "ERROR",
}

export const StockAdjustments: React.FC = () => {
    const {fetchData, token}  = useAuth();
    const [resultElements, setResultElements] = useState<React.ReactElement[]>([]);
    const [search, setSearch] = useState<Map<string, string>>(new Map<string, string>());    

    // const [queryState, setQueryState] = useState<IQuery>(
    //     {
    //         tableName: "sa_m24l_stock_adjustment",
    //         select: [],
    //         groupBy: [],
    //         join: [],
    //         orderBy: [ 
    //             {
    //                 fullColumnName: "created",
    //                 direction: "DESC",
    //                 cast: CastType.TIMESTAMP
    //             }
    //         ],
    //         where: [
    //             // {
    //             //     fullColumnName: "updated",
    //             //     value: null,
    //             //     operator: "NE",
    //             //     cast: CastType.STRING
    //             //   }
    //         ],
    //         mainTableOnly: false,
    //         includeExtraColumns: false,
    //         includeControlColumns: true,
    //         modifiedAfter: null,
    //         touchedBefore: null,
    //         isDirty: null,
    //         pageNum: 0,
    //         pageSize: 2500,
    //         frontEndOnly: null
    //     }        
    // );

   

    /* 
    Status 

    Stock Adjustments
    TO_PROCESS - Pending stock adjustment message received from M24L.
    PROCESSED - Stock adjustment message prcessed in SAP.
    ERROR - The was an error processing the stock adjustment.

    */

    return(
        <React.Fragment>
            <Container fluid className="p-0">
            <QueryListProvider>
                    <QueryList
                        listTitle={"Stock Adjustments - Activity Status"}
                        recordTitle={"Stock Adjustments - Activity Status"}
                        tableName={"sa_m24l_stock_adjustment"}
                        editTableName={"sa_m24l_stock_adjustment"}
                        editHasCompoundKey={false}
                        hasIntegrationStatusLegend={true}
                        errorCategoryName={'StockAdjustment'}
                        integrationstatusLegend={[
                            { status: 'ERROR', color: '#bf3636', description: 'The was an error processing the stock adjustment.'},
                            { status: 'TO_PROCESS', color: '#d4a53f', description: 'Pending stock adjustment message received from M24L.'},
                            { status: 'PROCESSED', color: '#3ec76b', description: 'Stock adjustment message prcessed in SAP.'}
                        ]}
                         modal={
                            {
                              modalProptBy: "m24l_reference",
                              tableName: "sa_m24l_stock_movement_out",
                              modalHasViewing: false,
                            }
                        }
                       join={[{
                            relationship: "notifications",
                            joinType: "LEFT"
                        }]} 
                        select={[
                            {
                                fullColumnName: "m24l_reference",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "item_code",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "from_zone",
                                aggregate: ""
                            }, 
                            {
                                fullColumnName: "to_zone",
                                aggregate: ""
                            },  
                            {
                                fullColumnName: "status",
                                aggregate: ""
                            },    
                            {
                                fullColumnName: "qty",
                                aggregate: ""
                            },    
                            {
                                fullColumnName: "reason_desc",
                                aggregate: ""
                            },                                         
                            {
                                fullColumnName: "created",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "updated",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "notifications.reference",
                                aggregate: "COUNT"
                            },
                        ]}
                        where={[]} 
                        orderBy={[   
                            {
                              fullColumnName: "created",
                              direction: "DESC",
                              cast: CastType.TIMESTAMP
                            }
                         ]} 
                        groupBy={[
                            "m24l_reference",
                            "item_code", 
                            "from_zone",
                            "to_zone",
                            "status",
                            "qty",
                            "reason_desc",
                            "created",
                            "updated",
                        ]}                   
                    />
                </QueryListProvider>
            </Container>
        </React.Fragment>
    );
}